import axios from "src/lib/axios";

/** --------------------- Token Package API --------------------- */

/**
 * Get all token packages (Admin only)
 * @returns {Array} data.package
 */
export const getAllTokenPackage = async () => {
  const { data: response } = await axios.get(`/token-packages`);
  return response.data;
};

/**
 * Get all token active packages (for user)
 * @returns
 */
export const getAllTokenActive = async () => {
  const { data: response } = await axios.get(`/token-packages/active`);
  return response.data;
};

/** --------------------- Token Order API --------------------- */

/**
 *
 * @param {number} page - page number
 * @param {number} page_size - number of items per page
 * @param {string} status - status of the token order => ["", "PENDING", "PAID", "CANCELLED", "EXPIRED", "FAILED"]
 * @returns
 */
export const getAllTokenOrder = async ({
  page,
  page_size,
  keyword = "",
  status = "",
  user = null,
}) => {
  const { data: response } = await axios.get(`/token-orders`, {
    params: {
      page: page + 1,
      limit: page_size,
      keyword: keyword,
      status: status,
      user: user,
    },
  });
  return response.data;
};

/**
 *
 * @param {string} orderId - token order _id
 * @returns
 */
export const getTokenOrderById = async (orderId) => {
  const { data: response } = await axios.get(`/token-orders/${orderId}`);
  return response.data;
};

/**
 *
 * @param {string} orderId - token order _id
 * @param {File} fileData - file data from input type file
 * @returns
 */
export const uploadTokenOrderReceipt = async (orderId, fileData) => {
  const { data: response } = await axios.post(
    `/token-orders/${orderId}/upload-receipt`,
    { receipt: fileData },
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    },
  );
  return response.data;
};

/**
 *
 * @param {string} orderId - token order _id
 * @returns
 */
export const processPaymentOrder = async (orderId) => {
  const { data: response } = await axios.post(`/token-orders/${orderId}/pay`);
  return response.data;
};

/**
 *
 * @param {number} page - page number
 * @param {number} page_size - number of items per page
 * @param {string} status - status of the token order => ["", "PENDING", "PAID", "CANCELLED", "EXPIRED", "FAILED"]
 * @returns
 */
export const getTokenOrderBySeller = async ({
  page,
  page_size,
  keyword = "",
  status = "",
  start_date = null,
  end_date = null,
}) => {
  const { data: response } = await axios.get(`/token-orders/my`, {
    params: {
      page: page + 1,
      limit: page_size,
      keyword: keyword,
      status: status,
      start_date: start_date,
      end_date: end_date,
    },
  });
  return response.data;
};

/**
 * Create token order
 * @param {string} packageId - token package _id
 * @param {string} payment_method - payment method
 * @param {string} billing.name - name of the billing
 * @param {string} billing.address - address of the billing
 * @param {boolean} billing.is_company - whether the billing is for a company => if true, tax_id is required
 * @param {string} billing.tax_id - tax id of the billing
 * @returns
 */
export const createTokenOrder = async ({
  packageId,
  payment_method,
  billing,
}) => {
  const { data: response } = await axios.post(`/token-orders`, {
    packageId: packageId,
    payment_method: payment_method,
    billing: billing,
  });
  return response.data;
};

/** --------------------- Token Wallet API --------------------- */

/**
 * Get all sellers' token wallet
 * @param {number} page - page number
 * @param {number} page_size - number of items per page
 * @param {string} user - seller's user._id
 * @param {string} source - source of token wallet null or ["admin", "seller"] // ?
 * @param {boolean} expired - filter by expired or not
 * @returns
 */
export const getAllTokenWallet = async ({
  page,
  page_size,
  user = null,
  source = null,
  expired = null,
}) => {
  const { data: response } = await axios.get(`/token-wallets`, {
    params: {
      page: page,
      limit: page_size,
      user: user,
      source: source,
      expired: expired,
    },
  });
  return response.data;
};

/**
 * Get user's token wallet
 * @param {string} userId - seller's user _id
 * @returns
 */
export const getTokenWalletByUser = async (userId) => {
  const { data: response } = await axios.get(`/token-wallets/user/${userId}`);
  return response.data;
};

/**
 * Get user's token balance
 * @param {string} userId - seller's user _id
 * @returns
 */
export const getTokenBalanceByUser = async (userId) => {
  const { data: response } = await axios.get(
    `/token-wallets/user/${userId}/balance`,
  );
  return response.data;
};

/**
 * Get current user's token balance
 * @returns
 */
export const getUserTokenBalance = async () => {
  const { data: response } = await axios.get(`/token-wallets/my/balance`);
  return response.data;
};

/** --------------------- Token Topup API --------------------- */

/**
 * Get selllers's token wallet
 * @param {string} userId - seller's user _id
 * @param {object} data - topup data
 * @param {number} data.amount - amount of tokens to add
 * @param {number} data.expiry_days - number of days until the tokens expire
 * @param {string} data.note - note for topup
 * @returns
 */
export const addTokenToUser = async (userId, data) => {
  const { data: response } = await axios.post(`/admin/tokens/${userId}`, data);
  return response;
};

/** --------------------- Token Transaction API --------------------- */

/**
 * Get user's token wallet transaction history
 * @param {number} page - page number
 * @param {number} page_size - number of items per page
 * @param {string} type - type of transaction ["TOPUP", "USAGE", "REFUND", "ADJUST", "EXPIRED"]
 * @param {string} start_date - start date of the transaction
 * @param {string} end_date - end date of the transaction
 * @returns
 */
export const getSellerTokenTransaction = async ({
  page,
  page_size,
  type,
  start_date,
  end_date,
}) => {
  const { data: response } = await axios.get(`/token-transactions/user`, {
    params: {
      page: page + 1,
      limit: page_size,
      type: type,
      start_date: start_date,
      end_date: end_date,
    },
  });
  return response.data;
};
